import Switch from 'rc-switch';
import React, { Fragment } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

function LegendsList({ legendsList, handleSelected, selected }) {
    return (
        <Fragment>
            <Row className="mt-2">
                <Colxx sm={3} className="mb-3">
                    Booking Number
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('number')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('number')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Space Name
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('name')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('name')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                Space Image
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('image')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('image')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                Space Details
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('details')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('details')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                Space Conditions
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('conditions')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('conditions')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                Space Instructions
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('instructions')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('instructions')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Hotel Name
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('hotelName')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('hotelName')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Hotel Logo
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('hotelLogo')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('hotelLogo')}
                    />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    Date
                </Colxx>
                <Colxx sm={3} className="mb-3">
                    <Switch
                        checked={selected
                            .split(',')
                            .includes('date')
                            ? true
                            : false}
                        onChange={(primary) => handleSelected('date')}
                    />
                </Colxx>
            </Row>
        </Fragment>
    );
}

export default LegendsList;